import { InputEntity } from "..";

export class Form230Input extends InputEntity {
  constructor(
    public readonly name: string,
    public readonly email: string,
    public readonly file: File,
    public readonly gdpr: boolean
  ) {
    super();
  }
}
